import { toastError } from '@/lib/toast-error';
import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

/**
 * Hook para obtener opciones por tipo
 * ✨ Migrated to tRPC with full type safety
 */
export function useInventoryOptions(optionType: 'clapbase' | 'categoria' | 'modelo' | 'status' | 'proveedor' | 'techMember' | 'financeMember') {
  const result = trpc.inventory.getOptionsByType.useQuery(optionType);

  return {
    data: result.data?.data || [],
    isLoading: result.isLoading,
    error: result.error,
  };
}

/**
 * Hook para obtener todas las opciones
 * ✨ Migrated to tRPC with full type safety
 */
export function useAllInventoryOptions() {
  return trpc.inventory.getAllOptions.useQuery();
}

/**
 * Hook para crear una nueva opción
 * ✨ Migrated to tRPC with full type safety
 */
export function useCreateOption() {
  const utils = trpc.useUtils();

  return trpc.inventory.createOption.useMutation({
    onSuccess: (_, variables) => {
      utils.inventory.getOptionsByType.invalidate(variables.optionType);
      utils.inventory.getAllOptions.invalidate();
      toast.success(`Opción "${variables.value}" agregada exitosamente`);
    },
    onError: (error) => {
      console.error('Error creating option:', error);
      toastError(error, 'common.toast.error_al_crear_opcion');
    },
  });
}

/**
 * Hook para eliminar una opción
 * ✨ Migrated to tRPC with full type safety
 */
export function useDeleteOption() {
  const { t } = useTranslation();
  const utils = trpc.useUtils();

  return trpc.inventory.deleteOption.useMutation({
    onSuccess: (_, variables) => {
      utils.inventory.getOptionsByType.invalidate(variables.optionType);
      utils.inventory.getAllOptions.invalidate();
      toast.success(t('hooks.inventoryoptions.opcion_eliminada_exitosamente'));
    },
    onError: (error) => {
      console.error('Error deleting option:', error);
      toastError(error, 'common.toast.error_al_eliminar_opcion');
    },
  });
}
